import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  List,
  Modal,
  notification,
  Popconfirm,
  Row,
  Spin,
} from "antd";
import { DATE_DISPLAY_FORMAT_HOURS_SECONDS } from "constants/dateFormats";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import TorichatService from "services/torichatService";
import BasicButtonPrimary from "components/BasicButtonPrimary";
import { CloseSquareOutlined, EditOutlined } from "@ant-design/icons";
import AIAssistantService from "services/aiAssistantService";

const { RangePicker } = DatePicker;
const CONTACT_TYPE = {
  USER: "Contact",
  STAFF: "User",
};

const TYPE_SYNC = {
  KNOWLEDGE: "KNOWLEDGE",
  GENERAL_INFOMATION: "GENERAL_INFOMATION",
};

export default function TorichatHistoryChat({ merchantCode }) {
  const { t: translation } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [currentChatId, setCurrentChatId] = useState(null);

  const [listConversation, setListConversation] = useState([]);
  const [totalNextConversation, setTotalNextConversation] = useState(0);
  const [isLoadingConversation, setIsLoadingConversation] = useState(false);
  const [filterSearchConversation, setFilterSearchConversation] = useState({
    filter: {},
    skip: 0,
    limit: 50,
    searchText: undefined,
    order: {
      key: "created_at",
      value: "desc",
    },
  });

  const [idChatConversation, setIdChatConversation] = useState(undefined);
  const [listChatData, setListChatData] = useState([]);
  const [totalNextPageChatData, setTotalNextPageChatData] = useState(0);
  const [filterSearchChatData, setFilterSearchChatData] = useState({
    filter: {},
    skip: 0,
    limit: 100,
    searchText: undefined,
    order: {
      key: "created_at",
      value: "desc",
    },
  });
  const listChatDataRef = useRef(null);

  const [checkedIdChat, setCheckedIdChat] = useState([]);
  const allCheckedIdChat = checkedIdChat.length === listChatData.length;
  const indeterminate = checkedIdChat.length > 0 && !allCheckedIdChat;

  const [optionsCheck, setOptionsCheck] = useState(false);

  const [typeSync, setTypeSync] = useState(undefined);
  const [formSync] = Form.useForm();
  const [loadingSync, setLoadingSync] = useState(false);

  const getListConversation = (filterSearchConversation) => {
    if (!merchantCode) {
      return setListConversation([]);
    }
    setIsLoadingConversation(true);
    TorichatService.getConversation(
      filterSearchConversation,
      merchantCode
    ).then((result) => {
      setIsLoadingConversation(false);
      const { data, totalNextPage } = result;
      setListConversation((prevData) => [...prevData, ...(data || [])]);
      setTotalNextConversation(totalNextPage || 0);
    });
  };

  useEffect(() => {
    getListConversation(filterSearchConversation);
  }, [merchantCode]);
  useEffect(() => {
    const newFilter = { ...filterSearchChatData, skip: 0 };
    setFilterSearchChatData(newFilter);
    getListChatData(newFilter);
  }, [idChatConversation, merchantCode]);

  const handleCheckAllConversation = (e) => {
    if (e.target.checked) {
      setCheckedIdChat(listChatData.map((item) => item.id));
    } else {
      setCheckedIdChat([]);
    }
  };

  // chọn / bỏ chọn từng item
  const handleCheckItemConversation = (id) => {
    if (checkedIdChat.includes(id)) {
      setCheckedIdChat(checkedIdChat.filter((i) => i !== id));
    } else {
      setCheckedIdChat([...checkedIdChat, id]);
    }
  };

  const getListChatData = (filterSearchChatData) => {
    if (loading) return;
    if (!merchantCode || !idChatConversation) {
      return setListChatData([]);
    }
    setLoading(true);
    TorichatService.getList(
      {
        ...filterSearchChatData,
        filter: { conversation_id: idChatConversation },
      },
      merchantCode
    )
      .then((result) => {
        const { data, totalNextPage } = result;
        if (filterSearchChatData.skip > 0) {
          setListChatData((prev) => [...prev, ...(data || [])]);
        } else {
          setTimeout(() => {
            if (listChatDataRef.current) {
              listChatDataRef.current.scrollTop =
                listChatDataRef.current.scrollHeight;
            }
          }, 100);
          setListChatData(data || []);
        }
        setTotalNextPageChatData(totalNextPage || 0);
      })
      .catch(() => {
        setListChatData([]);
        notification["error"]({
          message: "",
          description: translation("dataLoadFail"),
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleEditChat = (record) => {
    setCurrentChatId(record.id);
    form.setFieldValue("content", record.content);
  };

  const onSubmitDetailForm = (values) => {
    if (!currentChatId || isLoadingSubmit) return;
    const valuesUpdate = {
      id: currentChatId,
      content: values.content,
    };
    setIsLoadingSubmit(true);
    TorichatService.update(valuesUpdate, merchantCode)
      .then(() => {
        notification["success"]({
          message: "",
          description: translation("updateSuccess"),
        });
        const updated = listChatData.map((item) =>
          item.id === currentChatId
            ? { ...item, content: values.content }
            : item
        );
        setListChatData(updated);
      })
      .catch(() => {
        notification["error"]({
          message: "",
          description: translation("updateFailed"),
        });
      })
      .finally(() => {
        setCurrentChatId(false);
        form.resetFields();
        setIsLoadingSubmit(false);
      });
  };

  const onLoadMore = () => {
    const newFilter = {
      ...filterSearchConversation,
      skip: filterSearchConversation.skip + filterSearchConversation.limit,
    };
    setFilterSearchConversation(newFilter);
    getListConversation(newFilter);
  };

  const onSearch = (value) => {
    const newFilter = {
      ...filterSearchConversation,
      skip: 0,
      searchText: value,
    };
    setFilterSearchConversation(newFilter);
    getListConversation(newFilter);
  };
  const onLoadMoreChatData = () => {
    const newFilter = {
      ...filterSearchChatData,
      skip: filterSearchChatData.skip + filterSearchChatData.limit,
    };
    setFilterSearchChatData(newFilter);
    getListChatData(newFilter);
  };

  function getInitials(name = "", maxLetters = 2) {
    return name
      .split(/\s+/)
      .filter(Boolean)
      .map((w) => w[0])
      .join("")
      .toUpperCase()
      .slice(0, maxLetters);
  }

  const AvatarText = ({ name, colorBg = "bg-primary" }) => {
    return (
      <div
        style={{ width: 30, height: 30, minWidth: 30 }}
        className="d-flex align-items-center justify-content-center"
      >
        <div
          className={`position-relative w-100 h-100 rounded-circle ${colorBg}`}
        >
          <span className="position-absolute top-50 start-50 translate-middle text-white">
            {getInitials(name)}
          </span>
        </div>
      </div>
    );
  };

  const convertCheckboxToForm = () => {
    const filtered = listChatData.filter((item) =>
      checkedIdChat.includes(item.id)
    );

    const fullTextSearch = filtered
      .filter((item) => item.sender_type.toLowerCase() === "user")
      .map((item) => item.content.trim())
      .join("\n");

    const name = filtered
      .filter((item) => item.sender_type.toLowerCase() !== "user")
      .map((item) => item.content.trim())
      .join("\n");

    formSync.setFieldValue("fullTextSearch", fullTextSearch);
    formSync.setFieldValue("name", name);
  };

  return (
    <div>
      <style>{`
        .col-sm-12.col-md-5.col-lg-4 {
          flex: 0 0 auto;
          max-width: 100%;
          word-wrap: break-word;
          overflow-wrap: break-word;
          white-space: normal;
        }

        @media screen and (min-width: 768px) {
          .col-sm-12.col-md-5.col-lg-4 {
            max-width: 41.6667% !important; /* 5/12 */
          }
        }

        @media screen and (min-width: 992px) {
          .col-sm-12.col-md-5.col-lg-4 {
            max-width: 33.3333% !important; /* 4/12 */
          }
        }

        .col-sm-12.col-md-7.col-lg-8 {
          flex: 0 0 auto;
          max-width: 100%;
          word-wrap: break-word;
          overflow-wrap: break-word;
          white-space: normal;
        }

        @media screen and (min-width: 768px) {
          .col-sm-12.col-md-7.col-lg-8 {
            max-width: 58.3333% !important; /* 7/12 */
          }
        }

        @media screen and (min-width: 992px) {
          .col-sm-12.col-md-7.col-lg-8 {
            max-width: 66.6667% !important; /* 8/12 */
          }
        }
      `}</style>
      <Row>
        <Col
          className={`${
            idChatConversation ? "d-none" : ""
          } d-md-block col-sm-12 col-md-5 col-lg-4 px-0`}
          style={{ height: 500 }}
        >
          <div className="w-100 h-100">
            {/* <div className="border p-3">
              <Input.Search placeholder="Tìm kiếm" onSearch={onSearch} />
            </div> */}
            <div
              className="border h-100"
              style={{ height: "calc(100% - 65.45px)", overflowY: "auto" }}
            >
              {isLoadingConversation ? (
                <div className="d-flex justify-content-center align-items-center h-100">
                  <Spin />
                </div>
              ) : (
                <List
                  className="w-100"
                  dataSource={listConversation}
                  itemLayout="horizontal"
                  locale={{ emptyText: "Không có dữ liệu để hiển thị" }}
                  renderItem={(item) => (
                    <List.Item
                      key={item.id}
                      style={{ padding: "12px 0px 12px 1rem" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setIdChatConversation(item.id);
                        setListChatData([]);
                        setOptionsCheck(false);
                        setCheckedIdChat([]);
                      }}
                      className={
                        idChatConversation === item.id
                          ? "bg-info text-white"
                          : ""
                      }
                    >
                      <div className="d-flex align-items-center gap-3 w-100">
                        <AvatarText name={item.contact?.name} />
                        <div
                          className="d-flex flex-column gap-1"
                          style={{ width: "calc(100% - 48px)" }}
                        >
                          <span className="text-truncate fs-6 fw-bold w-100">
                            {item.contact?.name}
                          </span>
                          <span className="text-truncate w-100 display-block">
                            {item?.lastMessage?.[0]?.content}
                          </span>
                        </div>
                      </div>
                    </List.Item>
                  )}
                  loadMore={
                    totalNextConversation > 0 ? (
                      <div className="w-100 my-2 text-center">
                        <Button size="small" onClick={onLoadMore}>
                          Tải thêm
                        </Button>
                      </div>
                    ) : null
                  }
                ></List>
              )}
            </div>
          </div>
        </Col>
        <Col
          className={`${
            !idChatConversation ? "d-none" : ""
          } d-md-block col-sm-12 col-md-7 col-lg-8 px-0`}
          style={{ height: 500 }}
        >
          {loading ? (
            <div className="d-flex justify-content-center align-items-center border w-100 h-100">
              <Spin />
            </div>
          ) : !idChatConversation ? (
            <div className="d-flex justify-content-center align-items-center border w-100 h-100">
              Vui lòng chọn một cuộc trò chuyện
            </div>
          ) : (
            <div className="border w-100 h-100">
              <div className="w-100 d-flex align-items-center gap-2 justify-content-between border-bottom py-3 px-2">
                <span className="fw-bold fs-6 text-truncate">
                  {
                    listChatData?.find(
                      (item) => item.sender_type !== CONTACT_TYPE.STAFF
                    )?.sender_name
                  }
                </span>
                <div className="d-flex align-items-center">
                  <Button
                    size="small"
                    className="me-2"
                    onClick={() => {
                      setOptionsCheck(!optionsCheck);
                      setCheckedIdChat([]);
                    }}
                  >
                    {optionsCheck ? "Ẩn chọn" : "Chọn"}
                  </Button>
                  <CloseSquareOutlined
                    className="cursor-pointer"
                    style={{ fontSize: 26 }}
                    onClick={() => {
                      setIdChatConversation(undefined);
                      setListChatData([]);
                      setCheckedIdChat([]);
                      setOptionsCheck(false);
                      setTotalNextPageChatData(0);
                    }}
                  />
                </div>
              </div>
              {optionsCheck && (
                <div className="d-flex align-items-center gap-2 justify-content-between p-2 border-bottom">
                  <Checkbox
                    indeterminate={indeterminate}
                    checked={allCheckedIdChat}
                    onChange={handleCheckAllConversation}
                  ></Checkbox>
                  <div className="d-flex align-items-center gap-2 flex-wrap justify-content-end">
                    <Button
                      size="small"
                      shape="round"
                      onClick={() => {
                        setTypeSync(TYPE_SYNC.KNOWLEDGE);
                        convertCheckboxToForm();
                      }}
                    >
                      Thêm kiến thức chuyên môn
                    </Button>
                    <Button
                      size="small"
                      shape="round"
                      onClick={() => {
                        setTypeSync(TYPE_SYNC.GENERAL_INFOMATION);
                        convertCheckboxToForm();
                      }}
                    >
                       Thêm thông tin chung
                    </Button>
                  </div>
                </div>
              )}
              <div
                className="w-100 py-3 px-2"
                style={{
                  height: `calc(100% - ${optionsCheck ? "98.59px" : "58.8px"})`,
                  overflowY: "auto",
                }}
                ref={listChatDataRef}
              >
                <div className="w-100 d-flex flex-column gap-3">
                  {totalNextPageChatData > 0 && (
                    <div className="w-100 text-center">
                      <Button size="small" onClick={onLoadMoreChatData}>
                        Tải thêm
                      </Button>
                    </div>
                  )}
                  {listChatData
                    .sort(
                      (a, b) =>
                        new Date(a?.created_at) - new Date(b?.created_at)
                    )
                    .map((item, index) => {
                      return (
                        <div className="d-flex align-items-center gap-3">
                          {optionsCheck && (
                            <>
                              <div onClick={(e) => e.stopPropagation()}>
                                <Checkbox
                                  checked={checkedIdChat.includes(item.id)}
                                  onChange={(e) => {
                                    e.stopPropagation();
                                    handleCheckItemConversation(item.id);
                                  }}
                                />
                              </div>
                              <EditOutlined
                                style={{ fontSize: 16 }}
                                className="cursor-pointer"
                                onClick={() => {
                                  handleEditChat(item);
                                }}
                              />
                            </>
                          )}

                          {item?.sender_type === CONTACT_TYPE.STAFF ? (
                            <div
                              className="d-flex align-items-center gap-3 justify-content-end"
                              key={index}
                            >
                              <div className="w-75 border rounded p-2 bg-light">
                                <span className="d-flex text-justify">
                                  {item?.content}
                                </span>
                                <span
                                  className="d-flex fst-italic mt-1"
                                  style={{ fontSize: 10 }}
                                >
                                  {moment(item?.created_at).format(
                                    DATE_DISPLAY_FORMAT_HOURS_SECONDS
                                  )}
                                </span>
                              </div>
                              <AvatarText name={"Admin"} colorBg="bg-warning" />
                            </div>
                          ) : (
                            <div
                              className="d-flex align-items-center gap-3 justify-content-start"
                              key={index}
                            >
                              <AvatarText name={item.sender_name} />
                              <div className="w-75 border rounded p-2 bg-primary text-white">
                                <span className="d-flex text-justify">
                                  {item?.content}
                                </span>
                                <span
                                  className="d-flex fst-italic mt-1"
                                  style={{ fontSize: 10 }}
                                >
                                  {moment(item?.created_at).format(
                                    DATE_DISPLAY_FORMAT_HOURS_SECONDS
                                  )}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          )}
        </Col>
      </Row>

      <Modal
        className="modalCloseAntd"
        visible={currentChatId ? true : false}
        title={"Cập nhật tin nhắn"}
        onCancel={() => setCurrentChatId(false)}
        width={600}
        footer={
          <>
            <BasicButtonPrimary
              loading={isLoadingSubmit}
              onclick={() => {
                form.submit();
              }}
              text={translation("listSchedules.save")}
            />
          </>
        }
      >
        <Form form={form} onFinish={onSubmitDetailForm} layout="vertical">
          <div className="row">
            <div className="col-12">
              <Form.Item
                label={translation("torichat.reply")}
                name="content"
                rules={[
                  {
                    required: true,
                    message: translation("torichat.pleaseEnterContent"),
                  },
                ]}
              >
                <Input.TextArea
                  autoSize={{ minRows: 5, maxRows: 15 }}
                  placeholder={translation("torichat.content")}
                  autoFocus
                />
              </Form.Item>
            </div>
          </div>
        </Form>
      </Modal>
      {/* Modal for Add/Edit */}
      <Modal
        title={
          typeSync === TYPE_SYNC.KNOWLEDGE
            ? "Thêm kiến thức"
            : "Thêm thông tin chung"
        }
        visible={typeSync ? true : false}
        onCancel={() => {
          setTypeSync(undefined);
          formSync.resetFields();
        }}
        footer={
          <>
            <BasicButtonPrimary
              loading={loadingSync}
              onclick={() => {
                formSync.submit();
              }}
              text={translation("setting.ai.save")}
            />
          </>
        }
      >
        <Form
          form={formSync}
          layout="vertical"
          onFinish={async (values) => {
            const apiSync =
              typeSync === TYPE_SYNC.KNOWLEDGE
                ? AIAssistantService.addNewExpertKnowledge
                : typeSync === TYPE_SYNC.GENERAL_INFOMATION
                ? AIAssistantService.addNewGeneralInfo
                : undefined;

            if (loadingSync || !apiSync) return;
            setLoadingSync(true);

            const response = await apiSync({
              merchantCode: merchantCode,
              data: [values],
            });
            setLoadingSync(false);
            if (response.isSuccess) {
              notification["success"]({
                message: "",
                description: translation("createSuccess"),
              });
              setTypeSync(undefined);
              formSync.resetFields();
            } else {
              notification["error"]({
                message: "",
                description: translation("createFailed"),
              });
            }
          }}
        >
          <Form.Item
            name="name"
            label={translation("setting.ai.name")}
            rules={[
              {
                required: true,
                message: translation("setting.ai.pleaseEnterName"),
              },
            ]}
          >
            <Input.TextArea autoSize={{ minRows: 1, maxRows: 8 }} />
          </Form.Item>

          <Form.Item
            name="keywords"
            label={translation("setting.ai.keywords")}
            rules={[{ required: true, message: "Vui lòng nhập từ khóa" }]}
          >
            <Input.TextArea autoSize={{ minRows: 1, maxRows: 4 }} />
          </Form.Item>
          <Form.Item
            name="fullTextSearch"
            label={translation("setting.ai.fullTextSearch")}
            rules={[
              { required: true, message: "Vui lòng nhập nội dung trả lời" },
            ]}
          >
            <Input.TextArea autoSize={{ minRows: 4, maxRows: 8 }} />
          </Form.Item>
          <Form.Item
            name="fullOriginContent"
            label={translation("setting.ai.fullOriginContent")}
            rules={[
              {
                required: true,
                message: "Vui lòng nhập nội dung gốc tham khảo",
              },
            ]}
          >
            <Input.TextArea autoSize={{ minRows: 2, maxRows: 4 }} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
